import { create } from 'zustand';

const STORAGE_KEY = 'ccm-theme';
const DEFAULT_THEME = 'midnight';

const useThemeStore = create((set) => ({
  theme: localStorage.getItem(STORAGE_KEY) || DEFAULT_THEME,
  setTheme: (theme) => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
    set({ theme });
  },
  initTheme: () => {
    const theme = localStorage.getItem(STORAGE_KEY) || DEFAULT_THEME;
    document.documentElement.setAttribute('data-theme', theme);
    set({ theme });
  },
}));

export default useThemeStore;
